<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li class="mr-1">
            Committed. 
          </li>
          <li class="mr-1">
            Vibrant.
          </li>
          <li class="mr-1">
            Passionate
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; 2017-{{ year }} SYMnergetics Sdn Bhd (1198343-D)
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
